import React, { useEffect, useState } from 'react';
interface Purchase {
  name: string;
  city: string;
  plan: 'Esencial' | 'Completo';
}
const PURCHASES: Purchase[] = [{
  name: 'María G.',
  city: 'Córdoba',
  plan: 'Completo'
}, {
  name: 'Lucía P.',
  city: 'Rosario',
  plan: 'Esencial'
}, {
  name: 'Sofía C.',
  city: 'Buenos Aires',
  plan: 'Completo'
}, {
  name: 'Camila R.',
  city: 'Mendoza',
  plan: 'Esencial'
}, {
  name: 'Valentina M.',
  city: 'La Plata',
  plan: 'Completo'
}, {
  name: 'Florencia A.',
  city: 'Salta',
  plan: 'Esencial'
}, {
  name: 'Agustina B.',
  city: 'Mar del Plata',
  plan: 'Completo'
}, {
  name: 'Roberto M.',
  city: 'Buenos Aires',
  plan: 'Esencial'
}, {
  name: 'Diego L.',
  city: 'Neuquén',
  plan: 'Completo'
}, {
  name: 'Mateo F.',
  city: 'San Juan',
  plan: 'Esencial'
}];
const TIMES = ['hace unos segundos', 'hace 1 minuto', 'hace 2 minutos', 'hace 3 minutos', 'hace 5 minutos'];
const VISIBLE_MS = 6000; // cuánto tiempo se queda visible
const CYCLE_MS = 30000; // cada cuánto aparece uno nuevo
const INITIAL_DELAY_MS = 8000; // delay antes de mostrar el primero
function getInitials(name: string) {
  return name.split(' ').map(p => p[0]).join('').slice(0, 2).toUpperCase();
}
export function RecentPurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [timeLabel, setTimeLabel] = useState(TIMES[0]);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: ReturnType<typeof setTimeout>;
    let showTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      setTimeLabel(TIMES[Math.floor(Math.random() * TIMES.length)]);
      setVisible(true);
      hideTimer = setTimeout(() => {
        setVisible(false);
        setIndex(i => (i + 1) % PURCHASES.length);
      }, VISIBLE_MS);
    };
    // Primer toast después del delay inicial
    showTimer = setTimeout(show, INITIAL_DELAY_MS);
    // Ciclo recurrente
    const cycleTimer = setInterval(show, CYCLE_MS);
    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
      clearInterval(cycleTimer);
    };
  }, [dismissed]);
  if (dismissed) return null;
  const purchase = PURCHASES[index];
  return <div aria-live="polite" aria-atomic="true" className={['fixed left-4 bottom-4 sm:left-6 sm:bottom-6 z-40', 'w-[280px] sm:w-[320px] max-w-[calc(100vw-2rem)]', 'bg-card border border-cardBorder border-l-4 border-l-gold', 'rounded-xl shadow-[0_10px_40px_-10px_rgba(0,0,0,0.6),0_0_0_1px_rgba(201,168,76,0.15)]', 'p-3 sm:p-4', 'transition-all duration-500 ease-out', visible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-6 pointer-events-none'].join(' ')} role="status" data-id="element-164">
      <div className="flex items-start gap-3" data-id="element-165">
        {/* Avatar */}
        <div className="w-10 h-10 rounded-full bg-gold-gradient text-base font-black text-[13px] flex items-center justify-center shrink-0" data-id="element-166">
          {getInitials(purchase.name)}
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0" data-id="element-167">
          <p className="text-[13px] sm:text-[14px] text-white leading-snug" data-id="element-168">
            <span className="font-bold" data-id="element-169">{purchase.name}</span>
            <span className="text-text-muted" data-id="element-170"> de </span>
            <span className="font-semibold" data-id="element-171">{purchase.city}</span>
          </p>
          <p className="text-[12px] text-text-muted leading-snug mt-0.5" data-id="element-172">
            compró el plan{' '}
            <span className="text-gold font-semibold" data-id="element-173">{purchase.plan}</span>
          </p>
          <div className="flex items-center gap-1.5 mt-1.5" data-id="element-174">
            <span className="relative flex h-1.5 w-1.5" data-id="element-175">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-gold opacity-75" data-id="element-176" />
              <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-gold" data-id="element-177" />
            </span>
            <span className="text-[11px] text-text-muted" data-id="element-178">{timeLabel}</span>
          </div>
        </div>

        {/* Dismiss */}
        <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="text-[#666] hover:text-gold transition-colors shrink-0 -mr-1 -mt-1 p-1 text-lg leading-none" data-id="element-179">
          ×
        </button>
      </div>
    </div>;
}